<template>
  <!--
    	作者：kmdshop
    	时间：2020-06-20
    	描述：diy组件-参数设置-轮播图
    -->
  <div>
    <div class="common-form">
      <span>{{ curItem.name }}</span>
    </div>
    <el-form size="small" :model="curItem" label-width="100px">
  
      <el-form-item label="图片">
        <el-button @click="chooseImg">选择图片</el-button>

        <div v-if="curItem.params.logo" class="image-box">
          <img
            class="mt10"
            :src="curItem.params.logo"
            width="200"
          />
        </div>

      </el-form-item>


      <el-form-item label="文字一：" >
        <el-input v-model="curItem.params.title1" ></el-input>
      </el-form-item>

      <el-form-item label="文字一颜色：" >
          <div class="url-box" >
              <el-color-picker v-model="curItem.params.title1_color"></el-color-picker>
          </div>
      </el-form-item>



      <el-form-item label="文字二：" >
        <el-input v-model="curItem.params.title2" ></el-input>
      </el-form-item>

      <el-form-item label="文字二颜色：" >
          <div class="url-box" >
              <el-color-picker v-model="curItem.params.title2_color"></el-color-picker>
          </div>
      </el-form-item>


      <el-form-item label="文字三：" >
        <el-input v-model="curItem.params.title3" ></el-input>
      </el-form-item>


      <el-form-item label="文字三颜色：" >
          <div class="url-box" >
              <el-color-picker v-model="curItem.params.title3_color"></el-color-picker>
          </div>
      </el-form-item>



      <el-form-item label="颜色类型">
        <el-select placeholder="请选择类型" v-model="curItem.params.color_type">
          <el-option  v-for="(item,index) in curItem.params.type_arr" :key="index" :value="item.id" :label="item.text">
          </el-option>
        </el-select>

      </el-form-item>
      <el-form-item label="设置颜色：" >

        <div class="url-box" v-if="Number(curItem.params.color_type) == 1">
            <el-color-picker v-model="curItem.params.color1"></el-color-picker>
        </div>
        <div class="url-box" v-if="Number(curItem.params.color_type) == 2">
            <el-color-picker v-model="curItem.params.color1"></el-color-picker>
            <el-color-picker v-model="curItem.params.color2"></el-color-picker>
            <el-color-picker v-model="curItem.params.color3"></el-color-picker>
        </div>

      </el-form-item>


    
      <el-form-item label="跳转链接：" >
        <div class="d-s-c">
              <div class="url-box flex-1">
              <span class="key-name">链接名称：</span>
              <el-input :value="curItem.linkName+curItem.linkUrl"></el-input>
            </div>
            <div class="url-box ml10">
              <el-button type="primary" @click="changeLink(index)">选择链接</el-button>
            </div>
            </div>
        </el-form-item>
    </el-form>

    <Setlink
      v-if="is_linkset"
      :is_linkset="is_linkset"
      @closeDialog="closeLinkset"
      >选择链接</Setlink
    >

    <Upload
      v-if="isupload"
      :isupload="isupload"
      :config="{ total: 1 }"
      @returnImgs="returnImgsFunc"
    ></Upload>
  </div>
</template>

<script>
import Setlink from "@/components/setlink/Setlink";
import AdvApi from "@/api/adv.js";
import Upload from "@/components/file/Upload";
export default {
  components: {
    Setlink,
    Upload
  },
  data() {
    return {
      advList: [],
      /*是否选择链接*/
      is_linkset: false,
      index: null,
      isupload:false
    };
  },
  props: ["curItem", "selectedIndex"],
  created() {
    // this.getAdvList();
  },
  methods: {
    /*选择图片*/
    chooseImg() {
      this.isupload = true;
    },
    /*关闭选择图片*/
    returnImgsFunc(e) {
      this.isupload = false;
      this.curItem.params.logo = e[0].file_path;
   
    },
    formatTooltip(val) {
      return (val*2) + ' px';
    },
    formatTooltipa(val) {
      return (val);
    },
    /*选择链接*/
    changeLink(index) {
      this.is_linkset = true;
      this.index = index;
    },

    /*获取链接并关闭弹窗*/
    closeLinkset(e) {
      this.is_linkset = false;
      if (e) {
        this.curItem.linkUrl = e.url;
        this.curItem.linkName = "链接到" + " " + e.type + " " + e.name;
      }
    },
  },
};
</script>

<style>
.video {
  display: flex;
  align-items: center;
  justify-content: center;
}
.video video {
  width: 200px;
  height: 100px;
}
</style>



// WEBPACK FOOTER //
// src/views/page/page/diy/params/navDiy.vue